$(document)


.on(`change`, `#SingleOptionSelector-0, #SingleOptionSelector-1, #SingleOptionSelector-2`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const option_1    =   $( `#SingleOptionSelector-0` ).val();
    const option_2    =   $( `#SingleOptionSelector-1` ).val();
    const option_3    =   $( `#SingleOptionSelector-2` ).val();

    const variantTitle  =   `${ typeof option_1 !== 'undefined' && option_1 ? option_1 : '' }${ typeof option_2 !== 'undefined' && option_2 ? ` / ${ option_2 }` : '' }${ typeof option_3 !== 'undefined' && option_3 ? ` / ${ option_3 }` : '' }`;

    const variantId     =   getSelectOptionValueByText( `#ProductSelect-product-template option`, variantTitle );

    if ( typeof variantId !== 'undefined' && variantId ) {

      $( `#ProductSelect-product-template > option[value="${ variantId }"]` ).prop( `selected`, true );

      window.history.pushState({}, '', `${ currentPageURL }?variant=${ variantId }`);

    }

  }
  catch ( err ) {
    console.log( `ERROR #SingleOptionSelector-0`, err.message );
  }
})

.on(`click`, `.selector-wrapper .single-option-selector .option_item`, function( e ) {
  try {
    e.stopImmediatePropagation();

    $( this ).closest( `.single-option-selector` ).find( `.option_item` ).removeAttr( `selected` );

    $( this ).attr( `selected`, true );

    const option_1    =   $( `.selector-wrapper[option-index="1"] .single-option-selector .option_item[selected]` ).attr( `value` );
    const option_2    =   $( `.selector-wrapper[option-index="2"] .single-option-selector .option_item[selected]` ).attr( `value` );
    const option_3    =   $( `.selector-wrapper[option-index="3"] .single-option-selector .option_item[selected]` ).attr( `value` );

    const variantTitle  =   `${ typeof option_1 !== 'undefined' && option_1 ? option_1 : '' }${ typeof option_2 !== 'undefined' && option_2 ? ` / ${ option_2 }` : '' }${ typeof option_3 !== 'undefined' && option_3 ? ` / ${ option_3 }` : '' }`;

    const variantId     =   getSelectOptionValueByText( `#ProductSelect-product-template option`, variantTitle );

    if ( typeof variantId !== 'undefined' && variantId ) {

      $( `#ProductSelect-product-template > option[value="${ variantId }"]` ).prop( `selected`, true );

      window.history.pushState({}, '', `${ currentPageURL }?variant=${ variantId }`);

    }

  }
  catch ( err ) {
    console.log( `ERROR .selector-wrapper .single-option-selector .option_item`, err.message );
  }
})
;


function getSelectOptionValueByText( selector, text ) {
  try {
    let rtn;
    $( selector ).each(function(){
      const getText = $( this ).text().trim();

      if ( getText == text ) {

        rtn   =   $( this ).attr( `value` );

      }
    })

    return rtn;

  }
  catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

